module.exports = __webpack_public_path__ + "img/metaverse-trailer.e8b96eb5.jpg";